/**
 *  The higher the Level, the more will be logged
 */
export const logLevelValue = {
  off: 0,
  error: 1,
  warn: 2,
  info: 3,
  debug: 4,
  log: 5,
  trace: 6,
  all: 7
};

export const logLevels = Object.keys(logLevelValue);

export type Loglevel = keyof typeof logLevelValue;
